import { render } from "./ReserveStepLots.vue?vue&type=template&id=3b35fca2&scoped=true"
import script from "./ReserveStepLots.vue?vue&type=script&lang=js"
export * from "./ReserveStepLots.vue?vue&type=script&lang=js"

import "./ReserveStepLots.vue?vue&type=style&index=0&id=3b35fca2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b35fca2"]])

export default __exports__